import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-[14px] lg:rounded-lg font-semibold transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-5 lg:px-6 text-base lg:text-body active:translate-y-0",
  {
    variants: {
      variant: {
        primary:
          "bg-primary text-inverse shadow-btn hover:bg-primary-hover active:bg-primary-active hover:-translate-y-0.5 min-h-12 lg:min-h-[52px] [&_svg]:text-inherit",
        secondary:
          "border border-primary bg-white text-primary hover:bg-primary-light active:bg-primary-light min-h-12 lg:min-h-[52px] shadow-none hover:-translate-y-0.5",
        ghost: "bg-transparent text-foreground hover:text-primary hover:bg-primary-light active:bg-primary-light min-h-12",
        outline:
          "border border-primary bg-white text-primary hover:bg-primary-light active:bg-primary-light min-h-12 lg:min-h-[52px]",
        emergency:
          "bg-destructive text-inverse hover:bg-destructive/90 active:bg-destructive/95 min-h-12 lg:min-h-[52px] font-bold shadow-btn hover:-translate-y-0.5 [&_svg]:text-inherit",
        success:
          "bg-success text-inverse hover:bg-success/90 active:bg-success/95 min-h-12 [&_svg]:text-inherit",
        gradient:
          "bg-gradient-primary text-inverse shadow-btn hover:opacity-95 active:opacity-90 hover:-translate-y-0.5 min-h-12 lg:min-h-[52px] [&_svg]:text-inherit",
      },
      size: {
        default: "min-h-12 lg:min-h-[52px] px-5 lg:px-6 text-base lg:text-body",
        sm: "min-h-10 px-4 text-sm lg:text-caption",
        lg: "min-h-12 lg:min-h-[52px] px-5 lg:px-8 text-base lg:text-body",
        icon: "min-h-12 min-w-12 p-0",
      },
      fullWidth: {
        true: "w-full",
        false: "",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
      fullWidth: false,
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, fullWidth, type = "button", ...props }, ref) => (
    <button
      type={type}
      className={cn(buttonVariants({ variant, size, fullWidth }), className)}
      ref={ref}
      {...props}
    />
  )
);
Button.displayName = "Button";

export { Button, buttonVariants };
